<template>
  <div class="player">
  </div>
</template>

<script>
import VueHowler from 'vue-howler'
import EventBus from '@/utils/eventBus'
export default {
  mixins: [
    VueHowler
  ],
  created () {
    EventBus.$on('play', this.togglePlayback)
    EventBus.$on('stop', this.stop)
  },
  beforeDestroy () {
    EventBus.$off('play')
    EventBus.$off('stop')
  },
  computed: {
    playIcon () {
      return this.playing ? 'icon-pause' : 'icon-play'
    }
  },
  watch: {
    progress (val) {
      this.$emit('progress', val)
    },
    playing (val) {
      if (val) {
        this.$emit('play')
      } else {
        this.$emit('stop')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuAudioPlayer.vue